import { render } from "./CoinInfo.vue?vue&type=template&id=7b8c0302"
import script from "./CoinInfo.vue?vue&type=script&lang=js"
export * from "./CoinInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__